import { useGlobalPeriod } from "../context";
import moment from "moment";
import { PortfolioReportsControllerApi } from "@iliotech/generated-api";
import { useQuery } from "react-query";
import { API_BASE } from "../../constants/constants";
import { Period } from "@iliotech/generated-api";

export const useAllocationHistoryV1 = (
  portfolioId: string,
  overridePeriod?: Period
) => {
  const { period: contextPeriod } = useGlobalPeriod();
  const period = overridePeriod || contextPeriod;
  const from = !!period?.from
    ? moment(period.from).format("YYYY-MM-DD")
    : undefined;
  const to = !!period?.to ? moment(period.to).format("YYYY-MM-DD") : undefined;
  const api = new PortfolioReportsControllerApi(undefined, API_BASE);
  return useQuery(
    [`portfolio-allocation-history-v1`, { portfolioId, from, to }],
    () =>
      api.getPortfolioHistoryBreakdownUsingPOST({
        portfolioId,
        period: { from, to },
      })
  );
};
